<template>
    <div class="picture-vote">
        <div class="title">{{title}}</div>
        <div  class="mul-options">
            <div 
                :class="['option',isThreeOption&&'option-three',isTwoOption&&'option-two']" 
                v-for="(item,index) in options" 
                :key="item.id"  
                @click="goToVote(item)"
            >
                <div class="img-c"><img :src="item.optionUrl"/></div>
                <!-- 未投票 && 未结束 -->
                <div v-if="!isVoted&&!isFinish" class="mul-option-status-1" :style="getOptionStatus1Stype(index)">{{item.name}}</div>
                <!-- 已投票 || 已结束 -->
                <template v-else>
                    <div class="mul-option-status-2" :style="getOptionStatus2Stype(item,index)">
                        <!-- 未完成，已选择 蓝色 -->
                        <div :class="['name',isTwoOption&&'options-two']">
                            <div class="left">
                                <span class="text">{{item.name}}</span>
                                <img 
                                    v-if="userOptionId == item.id"
                                    class="selected-icon"
                                    :src="getOptionSelectIcon(index)"
                                />
                            <span :class="['percent',isTwoOption&&'two-option-percent']">{{item.percent}}%</span>
                            </div>
                        </div>
                        <div class="percent-bar"></div>
                    </div>
                </template>
            </div>
        </div>
        <!-- 提示信息 -->
        <Tips :fields="fields" :isFinish="isFinish"/>
    </div>
</template>
<script>
import Tips from './tips.vue'
import blueIcon from '../../../../images/icon_chose_blue@2x.png'
import greyIcon from '../../../../images/icon_chose_grey@2x.png'
export default {
    props: ['fields','isFinish'],
    components: {
        Tips
    },
    data() {
        return {
            blueIcon,
            redIcon: '//statics.itc.cn/mptc-mpfe/img/article/icon_vote_chose_b.png',
            greyIcon
        }
    },
    computed: {
        title() {
            return this.fields?.title
        },
        options() {
            return this.fields?.options
        },
        // 2个选项
        isTwoOption() {
            return this.options?.length == 2
        },
        // 3个选项
        isThreeOption() {
            return this.options?.length == 3
        },
        // 多于2个选项
        isMulOption() {
            return !this.isTwoOption
        },
        // 可投票状态
        canVote() {
            return !this.isFinish && !this.userOptionId
        },
        // 已投票
        isVoted() {
            return this.fields?.userOptionId || false
        },
        // 已选选项
        userOptionId() {
            return this.fields?.userOptionId
        },
    },
    methods: {
        getOptionStatus1Stype(index) {
            if(!this.isTwoOption) return {
                '--font-color': '#111',
                '--background-color': 'white',
            }
            const isLeft = index == 0
            return {
                '--font-color': 'white',
                '--background-color': isLeft ? '#4A70FF' : '#FF5E4D',
            }
        },
        getOptionStatus2Stype(item,index) {
            const isSelected = item.id == this.userOptionId
            // 2选项
            if(this.isTwoOption) {
                const isLeft = index == 0
                return {
                    '--font-color': this.isFinish ? '#999' : isLeft ? '#4A70FF' : '#FF5E4D',
                    '--font-size': '14px',
                    '--icon-size': '16px',
                    '--background-color': this.isFinish ? '#fff' : isLeft ? '#E9EDFF' : '#FFEBE9',
                    '--percent':item.percent+'%',
                    '--resultbar-left-color': this.isFinish ? '#999' : isLeft ? '#4A70FF' : '#FF5E4D',
                    '--resultbar-right-color': this.isFinish ? 'rgba(204,204,204,0.4)' : isLeft ? 'rgba(74,112,255,0.4)' : 'rgba(255,94,77,0.4)',
                }
            }else { // 多选项
                return {
                    '--font-size': this.isFinish ? '13px': this.isVoted ? '13px': '14px',
                    '--icon-size': '12px',
                    '--font-color': this.isFinish ? '#666' : isSelected ? '#1842DF' : '#666',
                    '--background-color': this.isFinish ? '#fff' : isSelected ? '#F2F5FF' : '#fff',
                    '--resultbar-left-color': this.isFinish ? '#999' : isSelected ? 'rgba(74,112,255,0.8)' : '#999',
                    '--resultbar-right-color': this.isFinish ? '#e8e8e8' : isSelected ? '#D2DCFF' : '#e8e8e8',
                    '--percent-font-color': this.isFinish ? '#999' : isSelected ? '#4A70FF' : '#999',
                    '--percent':item.percent+'%'
                }
            }
        },
        getOptionSelectIcon(index) {
            if(this.isTwoOption && !this.isFinish) {
                if(index == 0)return this.blueIcon
                if(index == 1)return this.redIcon
            }
            if(this.isFinish)return this.greyIcon
            return this.blueIcon
        },
        goToVote(item) {
            this.$emit('sendVote',item)
        }
    }
}
</script>
<style lang="less" scoped>
.picture-vote {
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    background: #F8F8F8;
    border-radius: 4px; 
    padding: 20px; 
    font-family: PingFangSC, PingFang SC;
    margin-bottom: 20px;
    font-weight: 500;
    .title {
        font-weight: 600;
        font-size: 20px;
        color: #111111;
        line-height: 28px;
        text-align: left;
        font-style: normal;
    }
    .mul-options {
        margin-top: 16px;
        display: flex;
        box-sizing: border-box;
        align-items: stretch;
        .option {
            margin-right: 8px;
            border-radius: 8px;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden; /* 确保内容不会溢出 */
            border: 1px solid rgba(0,0,0,0.05);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            .img-c {
                position: relative;
                width: 100%;
                padding-top: 75%;
                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px 8px  0px 0px;
                    margin: 0 !important;
                }
            }
            .mul-option-status-1 {
                height: 44px;
                line-height: 44px;
                padding: 0 12px;
                background: var(--background-color);
                color: var(--font-color);
                white-space: nowrap; /* 禁止换行 */
                overflow: hidden; /* 隐藏溢出的内容 */
                text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
                text-align: center; /* 文字居中对齐 */
                max-width: 100%; /* 限制最大宽度 */
                font-size: 14px;
            }
            .mul-option-status-2 {
                flex: 1;
                background: #fff;
                font-weight: 500;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                .name {
                    
                    flex: 1;
                    display: flex;
                    align-items: center;
                    white-space: nowrap; /* 确保文本和图片在同一行显示，直到换行 */
                    font-weight: 500;
                    font-size: var(--font-size);
                    background: var(--background-color);
                    color: var(--font-color);
                    padding: 9px 12px;
                    .left {
                        flex: 1;
                        position: relative;
                        display: inline-block;
                        vertical-align: middle; /* 保持多个块顶部对齐 */
                        white-space: normal; /* 允许文本在块内换行 */
                        line-height: 18px;
                    }
                    .text {
                        margin-right: 4px;
                        line-height: 18px;
                    }
                    .selected-icon {
                        display: inline !important;
                        height: var(--icon-size);
                        vertical-align: middle; /* 垂直对齐图片和文字 */
                        margin: 0!important;
                        margin-right: 4px !important;
                        margin-top: -2px !important; /* 调整图片的位置，使其垂直居中 */
                    }
                    .percent {
                        color: var(--percent-font-color);
                        font-size: var(--font-size);
                    }
                    .two-option-percent {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                    }
                }
                .percent-bar {
                    height: 8px;
                    border-radius: 0px 0px 8px 8px;
                    background: linear-gradient(to right,var(--resultbar-left-color) var(--percent),var(--resultbar-left-color) var(--percent),var(--resultbar-right-color) var(--percent),var(--resultbar-right-color) 100%);
                }
                .options-two {
                    justify-content: space-between;
                }
            }
        }
        .option-three {
            margin-right: 10px;
        }
        .option-two {
            margin-right: 12px;
            border: none;
        }
        .option:last-child {
            margin-right: 0;
        }
    }

}
</style>